import React from 'react'
import { Grid, PageSection as Section, VerticalSpacer, Button } from '@superhi/design'

import LibraryPostArticleCard from '../../LibraryPostArticleCard'
import LibraryPostVideoCard from '../../LibraryPostVideoCard'

import { API } from 'src/api'
import { SUPERLIBRARY_URL } from 'src/config'

const LIBRARY_HOME_PATH = `${SUPERLIBRARY_URL}`
const VS_1_AMOUNT = { small: 24, medium: 24, large: 32 }
const GRID_1_SLIDER = { small: true, medium: true }
const GRID_1_CELL_1_SPAN = { small: 3, medium: 3, large: 4 }

type Props = API.SuperLibraryPostsComponent &
  Pick<
    React.ComponentProps<typeof Section>,
    | 'collapseTopPadding'
    | 'collapseBottomPadding'
    | 'decorationName'
    | 'decorationPosition'
    | 'subtitleMaxWidth'
    | 'noTopPadding'
  > & {
    title?: string
    subtitle?: string
    imagesLazy?: boolean
    headingLevel?: number
  }

const SuperLibraryPosts: React.FC<React.PropsWithChildren<Props>> = ({
  title = 'The SuperLibrary',
  subtitle = "View our growing collection of resources, articles and tutorials. We're adding new things to read, learn and watch every week!",
  collapseBottomPadding,
  collapseTopPadding,
  decorationName,
  decorationPosition,
  imagesLazy = false,
  subtitleMaxWidth,
  noTopPadding,
  nodes,
  headingLevel = 2,
}) => {
  const posts = nodes || []

  return (
    <Section
      title={title}
      subtitle={subtitle}
      subtitleMaxWidth={subtitleMaxWidth}
      footer={
        <Button href={LIBRARY_HOME_PATH} isExternal>
          Visit the SuperLibrary
        </Button>
      }
      collapseBottomPadding={collapseBottomPadding}
      collapseTopPadding={collapseTopPadding}
      decorationName={decorationName}
      decorationPosition={decorationPosition}
      noTopPadding={noTopPadding}
      headingLevel={headingLevel}
    >
      <VerticalSpacer amount={VS_1_AMOUNT}>
        <Grid slider={GRID_1_SLIDER}>
          {posts.map((post): React.ReactElement => {
            switch (post.__typename) {
              case 'LibraryPostArticle': {
                return (
                  <Grid.Cell key={post.slug} span={GRID_1_CELL_1_SPAN}>
                    <LibraryPostArticleCard {...post} imageLazy={imagesLazy} />
                  </Grid.Cell>
                )
              }
              case 'LibraryPostVideo': {
                return (
                  <Grid.Cell key={post.slug} span={GRID_1_CELL_1_SPAN}>
                    <LibraryPostVideoCard {...post} imageLazy={imagesLazy} />
                  </Grid.Cell>
                )
              }
            }
          })}
        </Grid>
      </VerticalSpacer>
    </Section>
  )
}

export default SuperLibraryPosts
